import { render, staticRenderFns } from "./DealItemModal.vue?vue&type=template&id=5e5dd136&scoped=true&"
import script from "./DealItemModal.vue?vue&type=script&lang=js&"
export * from "./DealItemModal.vue?vue&type=script&lang=js&"
import style0 from "./DealItemModal.vue?vue&type=style&index=0&id=5e5dd136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5dd136",
  null
  
)

export default component.exports